import { createContext, type ReactNode, useContext } from "react";

import type { BranchingGateway } from "./branching-gateway";
import { HttpBranchingGateway } from "./http-branching-gateway";

const BranchingGatewayContext = createContext<BranchingGateway | null>(null);

const defaultGateway = new HttpBranchingGateway();

type BranchingProviderProps = { children: ReactNode; gateway?: BranchingGateway };

export function BranchingProvider({ children, gateway = defaultGateway }: BranchingProviderProps) {
  return <BranchingGatewayContext.Provider value={gateway}>{children}</BranchingGatewayContext.Provider>;
}

export function useBranchingGateway(): BranchingGateway {
  const g = useContext(BranchingGatewayContext);
  if (!g) {
    throw new Error("useBranchingGateway must be used within BranchingProvider");
  }
  return g;
}

type BranchingProviderForTestProps = { children: ReactNode; gateway: BranchingGateway };

export function BranchingProviderForTest({ children, gateway }: BranchingProviderForTestProps) {
  return <BranchingGatewayContext.Provider value={gateway}>{children}</BranchingGatewayContext.Provider>;
}
